module.exports = __webpack_public_path__ + "static/img/img_logo_12.47e39795.png";